module.exports = __webpack_public_path__ + "static/media/facebook.c4392b23.svg";